import React from "react";
import BqnContext from "common/BqnContext";
import ClusterChart from "./ClusterChart";
import { linesFromHours, oneDecimalWithPercentage } from "./utils";
import { useContext, useState } from "react";
import { useSelection } from "common/graphs/Legends";
import ColumnsGrid from "common/layouts/ColumnsGrid";

export const ClusterCongestionCharts = ({range, hours}) => {
    const [interactionData, setInteractionData] = useState(null);
    const { bqns } = useContext(BqnContext);

    const fields = bqns.map((bqn) => ({
      name: bqn.bqnId,
      label: `BQN ${bqn.bqnId}`,
    }));

    const [selection, doToggle] = useSelection(fields);

    const lines = linesFromHours(hours);

    return (
      <ColumnsGrid columns={2} minWidth="7cm" gap="0px">
        <ClusterChart
          titles={["Total Throughput Downlink", "Total Throughput Uplink"]}
          yAxisUnits="Mbps"
          yTooltipFormat={(d) =>
            d === undefined || d === null ? undefined : `${d} Mbps`
          }
          key="throughput"
          type="throughput"
          attrs={["DN", "UP"]}
          range={range}
          hours={hours}
          command={`show statistics volume mbps-max hours ${hours} interval 5 bqn-all`}
          interactionData={interactionData}
          setInteractionData={setInteractionData}
          fields={fields}
          selection={selection}
          doToggle={doToggle}
        />
        <ClusterChart
          titles={["Latency Over Time"]}
          yAxisUnits="milliseconds"
          yTooltipFormat={(d) =>
            d === undefined || d === null ? undefined : `${d} ms`
          }
          key="latency"
          type="latency"
          attrs={["RTT-80%-DN-ms", "RTT-MED-DN-ms", "RTT-MIN-DN-ms"]}
          range={range}
          hours={hours}
          command={`show statistics latency-percentile lines ${lines} bqn-all`}
          interactionData={interactionData}
          setInteractionData={setInteractionData}
          fields={fields}
          selection={selection}
          doToggle={doToggle}
        />
        <ClusterChart
          titles={["Average traffic under congestion"]}
          yAxisUnits="% of total traffic"
          yTooltipFormat={oneDecimalWithPercentage}
          key="congestion"
          type="congestion"
          attrs={["CONGEST%"]}
          range={range}
          hours={hours}
          command={`show statistics congestion short lines ${lines} bqn-all`}
          interactionData={interactionData}
          setInteractionData={setInteractionData}
          fields={fields}
          selection={selection}
          doToggle={doToggle}
        />
        <ClusterChart
          titles={["Average TCP Retransmissions Over Time"]}
          yAxisUnits="retransmissions-%"
          yTooltipFormat={oneDecimalWithPercentage}
          key="retransmissions"
          type="retransmissions"
          attrs={["RTX%-ACCESS"]}
          range={range}
          hours={hours}
          command={`show statistics retransmission lines ${lines} bqn-all`}
          interactionData={interactionData}
          setInteractionData={setInteractionData}
          fields={fields}
          selection={selection}
          doToggle={doToggle}
        />
        <ClusterChart
          titles={["Average traffic with ACM"]}
          yAxisUnits="% of total traffic"
          yTooltipFormat={oneDecimalWithPercentage}
          key="acm"
          type="acm"
          attrs={["ACM%"]}
          range={range}
          hours={hours}
          command={`show statistics congestion short lines ${lines} bqn-all`}
          interactionData={interactionData}
          setInteractionData={setInteractionData}
          fields={fields}
          selection={selection}
          doToggle={doToggle}
        />
      </ColumnsGrid>
    );
}
